var map = {
	"./add.svg": "58n+",
	"./checkedService.svg": "APne",
	"./checkedService1.svg": "jR/r",
	"./cloudfile.svg": "00qg",
	"./docx.svg": "t4uj",
	"./emoji.svg": "Lz1f",
	"./empty-data.svg": "1iAM",
	"./emptyStar.svg": "pDuk",
	"./file.svg": "fQ0v",
	"./folder.svg": "XXSE",
	"./fullStar.svg": "wpx/",
	"./lenovoTool.svg": "GL53",
	"./message.svg": "G2zY",
	"./myProduct.svg": "ukXO",
	"./pdfx.svg": "jtEg",
	"./photo.svg": "DkCd",
	"./pic.svg": "OSsC",
	"./pptx.svg": "+x/n",
	"./product.svg": "UHi4",
	"./rar.svg": "4G86",
	"./repair.svg": "V1dC",
	"./service.svg": "nCjf",
	"./service1.svg": "1rFW",
	"./station.svg": "AIxq",
	"./success.svg": "C5yd",
	"./text.svg": "meoi",
	"./textx.svg": "oSKy",
	"./ticketBanner.svg": "3Xr9",
	"./unknown.svg": "wOos",
	"./upload.svg": "P/TB",
	"./videox.svg": "XX9X",
	"./vipService.svg": "Vs2A",
	"./xlsx.svg": "+EMO",
	"./zipx.svg": "Uuah"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 15 16